var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowCollapseSvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 1618873046"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.9355 9.49996C18.9355 10.0077 18.5239 10.4193 18.0162 10.4193L7.64354 10.4193C7.64648 10.4218 7.6493 10.4242 7.65225 10.4268C7.9571 10.6849 8.27912 10.9378 8.58043 11.1744C8.60384 11.1927 8.62701 11.2109 8.65017 11.2292C8.95013 11.4648 9.26541 11.7126 9.46337 11.9052C9.82756 12.2591 9.83577 12.8411 9.48188 13.2052C9.12799 13.5694 8.54598 13.5776 8.18192 13.2237C8.07 13.115 7.84715 12.9365 7.51447 12.6751C7.49032 12.6561 7.4658 12.6369 7.44092 12.6174C7.14415 12.3845 6.7959 12.1112 6.46358 11.8296C6.10748 11.5278 5.73754 11.19 5.44984 10.8523C5.30581 10.6831 5.16361 10.4924 5.05378 10.2872C4.94787 10.0892 4.83878 9.81658 4.83878 9.49996C4.83878 9.18333 4.94787 8.91072 5.05378 8.71275C5.16361 8.50755 5.30581 8.31682 5.44984 8.14766C5.73754 7.80995 6.10748 7.47212 6.46358 7.17033C6.7959 6.88876 7.14415 6.61545 7.44092 6.38246C7.4658 6.36294 7.49032 6.34371 7.51447 6.32478C7.84715 6.06344 8.07 5.88494 8.18192 5.77621C8.54598 5.42233 9.12799 5.43059 9.48188 5.79469C9.83577 6.15877 9.82756 6.74082 9.46338 7.0947C9.26541 7.28727 8.95013 7.53513 8.65017 7.77072C8.62701 7.78899 8.60384 7.80725 8.58043 7.82552C8.27912 8.0621 7.9571 8.31498 7.65225 8.57313C7.6493 8.57571 7.64648 8.57816 7.64354 8.58061L18.0162 8.58061C18.5239 8.58061 18.9355 8.99223 18.9355 9.49996Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.919512 -4.0186e-08C1.42724 -1.79926e-08 1.83887 0.411611 1.83887 0.919349L1.83887 18.0807C1.83887 18.5884 1.42724 19 0.919512 19C0.411783 19 0.000156782 18.5884 0.000156804 18.0807L0.000157554 0.919349C0.000157577 0.411611 0.411783 -6.23794e-08 0.919512 -4.0186e-08Z",
    fill: "#F5F5F5"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowCollapseSvg);
export default __webpack_public_path__ + "static/media/ArrowCollapseSvg.2fd9831bc3fd083dccadc74e348e0946.svg";
export { ForwardRef as ReactComponent };